import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Priority {
  id: string
  name: string
}

export interface UsePrioritiesResult {
  priorities: Priority[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function usePriorities(fetchOnMount = false): UsePrioritiesResult {
  const [priorities, setPriorities] = useState<Priority[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ priorities: Priority[] }>('/admin/conversation-management/priorities/dropdown')
      setPriorities(res.priorities || [])
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to fetch priorities')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (fetchOnMount) {
      void refetch()
    }
  }, [fetchOnMount, refetch])

  return { priorities, loading, error, refetch }
}
